import * as SentryReact from '@sentry/react';
import * as SentryNextJS from '@sentry/nextjs';
import { isChromeExtension } from '../config';

export default isChromeExtension ? SentryReact : SentryNextJS;
